export default "__VITE_ASSET__CISv73tR__"